import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
} from '@angular/core';
import { UiSegmentedOption } from '../../types/ui-segmented-option.interface';
import { UiSegmentedComponent } from '../ui-segmented/ui-segmented.component';

@Component({
  selector: 'ui-segmented-control',
  imports: [UiSegmentedComponent],
  templateUrl: './ui-segmented-control.component.html',
  styleUrl: './ui-segmented-control.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiSegmentedControlComponent {
  public readonly options: InputSignal<readonly UiSegmentedOption[]> =
    input.required<readonly UiSegmentedOption[]>();
  public readonly activeOptionId: InputSignal<string> = input.required<string>();
  public readonly ariaLabel: InputSignal<string> = input.required<string>();
  public readonly activeOptionIdChange: OutputEmitterRef<string> = output<string>();

  protected handleActiveOptionIdChange(optionId: string): void {
    this.activeOptionIdChange.emit(optionId);
  }
}
